
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Col, Row, Spinner } from "reactstrap";
import BaseLayout from "@components/BaseLayout";
import PageError from "@components/common/PageError";
import PageNavigation from "@components/common/PageNavigation";
import ShuffleCard from "@components/common/ShuffleCard";
import TranslatedHtml from "@components/common/TranslatedHtml";
import ErrorPage from "@components/ErrorPage";
import ExtendedCategoryCard from "@components/marketplace/categories/ExtendedCategoryCard";
import MarketFilterTabs, { MarketTabItems } from "@components/marketplace/MarketFilterTabs";
import { useCategories } from "@services/hooks/useCategories";
import { useCurrentProcess } from "@services/pageHelpers";
import { getStringFromQuery, Routes } from "@services/routes";
import { MODULE_EXTENDED_CATEGORIES_AVAILABLE } from "config";
/**
 * this page shows information about categories.
 *
 * @todo move to /process/[id]/ for multi-mandant
 */
const CategoryPage = (): JSX.Element => {
    const { t } = useTranslation("common");
    const router = useRouter();
    // call this page with url parameter ?problemlotterie to show ShuffleCard
    const showShuffleCard = getStringFromQuery(router, "problemlotterie") !== null;
    const { currentProcess, processErrorOrSpinnerPage, processRequest } = useCurrentProcess();
    const { categories, categoryRequest, errorOrSpinnerPage: categoriesErrorOrSpinnerPage } = useCategories();
    const [allProblems, setAllProblems] = useState<string[]>(null);
    useEffect(() => {
        // extract all problems of all categories, when all categories have been loaded
        // for ShuffleCard
        let problemList: string[] = [];
        categories?.forEach(c => {
            problemList = problemList.concat(c.problems || []);
        });
        setAllProblems(problemList);
    }, [categories?.length]);
    if (!MODULE_EXTENDED_CATEGORIES_AVAILABLE) {
        return <ErrorPage statusCode={404} error={"failure.moduleNotAvailable"}/>;
    }
    if (processErrorOrSpinnerPage) {
        return processErrorOrSpinnerPage;
    }
    if (categoriesErrorOrSpinnerPage) {
        return categoriesErrorOrSpinnerPage;
    }
    return <BaseLayout pageTitle={currentProcess?.name ? currentProcess.name : t("page.process.categories.title")}>
    <Row>
      <Col className="col text-center">
        <MarketFilterTabs chosenItem={MarketTabItems.ExtendedCategories}/>
      </Col>
    </Row>
    <Row>
      <Col className="col">
        <h1>{t("page.process.categories.heading")}</h1>
        <Row>
          <Col md={showShuffleCard && 8} className="blocksatz"><TranslatedHtml content="page.process.categories.intro"/></Col>
          {showShuffleCard && allProblems?.length > 0 && <Col>
            <ShuffleCard textList={allProblems} title={t("page.process.categories.solutionWanted")}/>
          </Col>}
        </Row>
        <PageNavigation leftNavigation={{ href: Routes.Marketplace, title: "common:goto.marketplace" }}/>
        <PageError error={processRequest?.loadingError}/>
        <PageError error={categoryRequest?.loadingError}/>

        {categories?.map((category) => <ExtendedCategoryCard key={category.id} category={category}/>)}
        {(processRequest?.isLoading || categoryRequest?.isLoading) && <Spinner />}
      </Col>
    </Row>
  </BaseLayout>;
};
export default CategoryPage;

    async function __Next_Translate__getStaticProps__191dbbefb30__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/process/categories',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__191dbbefb30__ as getStaticProps }
  